import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { Alert } from "reactstrap";

import { getAuthRoleNames } from "../../services/authService";
import { getMySubscription } from "../../services/subscriptionService";

const SubscriptionBanner = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [showPastDueBanner, setShowPastDueBanner] = useState(false);

  const isOwner = getAuthRoleNames().includes("owner");

  useEffect(() => {
    if (!isOwner || location.pathname === "/suspended") {
      setShowPastDueBanner(false);
      return;
    }

    let isMounted = true;

    const loadSubscriptionStatus = async () => {
      try {
        const response = await getMySubscription();

        if (isMounted) {
          setShowPastDueBanner(response.data.status === "past_due");
        }
      } catch {
        if (isMounted) {
          setShowPastDueBanner(false);
        }
      }
    };

    loadSubscriptionStatus();

    return () => {
      isMounted = false;
    };
  }, [isOwner, location.pathname]);

  if (!isOwner || !showPastDueBanner) {
    return null;
  }

  return (
    <Alert
      color="warning"
      className="mb-0 rounded-0 border-0 border-bottom subscription-past-due-banner"
      role="alert"
    >
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 px-2">
        <div className="d-flex flex-wrap align-items-center gap-2">
          <i className="ri-alarm-warning-line fs-18" aria-hidden="true" />
          <span>{t("subscription.banner.past_due_warning")}</span>
        </div>
        <Link to="/settings/subscription" className="fw-medium text-decoration-underline">
          {t("subscription.banner.manageLink")}
        </Link>
      </div>
    </Alert>
  );
};

export default SubscriptionBanner;
